module.exports = __webpack_public_path__ + "static/eindruecke3-4b16dd6d1eb167b5a3855fac0c3adbeb.jpg";